var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 44,
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6311 33.3598C29.943 33.5545 16.099 33.9244 2.41087 34.1191L0.775299 7.11274C15.1255 7.05433 29.1252 6.99591 43.4754 6.9375C43.0081 15.8942 42.8134 24.4225 43.6311 33.3792V33.3598Z",
    fill: "#D8D7F4",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3951 7.38651L21.2393 1C26.5744 1.17524 31.9094 1.33101 37.2445 1.50625C37.2445 3.47283 37.225 5.41993 37.2056 7.38651C37.3029 7.21127 37.4003 7.01656 37.4976 6.84132",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3132 15.8756C14.5608 18.7379 15.0476 22.7684 17.4036 25.1439C19.0781 26.8379 21.6093 27.6556 23.9458 27.2662C27.2754 26.7016 29.9819 23.6251 30.1182 20.2566C30.4102 12.8382 20.2658 9.37231 16.3132 15.8756Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3584 43.0002C47.7028 43.0002 51.2247 39.4783 51.2247 35.1339C51.2247 30.7894 47.7028 27.2676 43.3584 27.2676C39.0139 27.2676 35.4921 30.7894 35.4921 35.1339C35.4921 39.4783 39.0139 43.0002 43.3584 43.0002Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.562 35.2268L47.3309 34.9736",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3199 31.3359L43.5731 39.1049",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/addPhoto.aa39300b93b80efa44714dd91360459b.svg";
export { ForwardRef as ReactComponent };